import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/aa-offer": [6],
		"/app-choice": [7],
		"/assessment-purchase": [8],
		"/cancel-subscription": [9,[2]],
		"/cancel-subscription/assessment-center": [10,[2]],
		"/cancel-subscription/cancel-feedback": [11,[2]],
		"/cancel-subscription/confirmation": [12,[2]],
		"/cancel-subscription/pause": [13,[2]],
		"/cancel-subscription/pause/manage": [14,[2]],
		"/cancel-subscription/pause/success": [15,[2]],
		"/cancel-subscription/save-offer": [16,[2]],
		"/cancel-subscription/success": [17,[2]],
		"/claimed-offer": [18],
		"/classic": [19],
		"/create-account": [20],
		"/create-account/offer/[offer_hash]": [21],
		"/debug/experiment-assign": [22],
		"/desktop-choice": [23],
		"/download-app": [24],
		"/email-preferences": [25],
		"/expired": [26],
		"/forgot-password": [27],
		"/get-started": [28],
		"/giveaway/family-vacation-2026": [29],
		"/inbound-gateway": [30],
		"/inside-pw": [31],
		"/link-entry": [32],
		"/login-account-selection": [35],
		"/login-expired-link": [36],
		"/login-redeemed-link": [37],
		"/login-same-device-success": [38],
		"/login-secondary-device-success": [39],
		"/login": [33,[3]],
		"/login/too-many-attempts": [34,[3]],
		"/logout": [40],
		"/magic-link-pending": [41],
		"/paddle": [42],
		"/parent-section": [43,[4]],
		"/parent-section/assessment-center": [44,[4]],
		"/parent-section/membership": [45,[4]],
		"/parent-section/membership/billing": [46,[4]],
		"/parent-section/membership/payment": [47,[4]],
		"/password-reset-success": [49],
		"/password-reset": [48],
		"/premium": [50],
		"/printables": [51],
		"/prospect-register": [52],
		"/purchase-gift": [53],
		"/qr-entry": [54],
		"/reactivation": [55],
		"/redeem": [56],
		"/reset-link-expired": [57],
		"/starter-pack": [58],
		"/subscription-consume": [61],
		"/subscription": [59],
		"/subscription/offer/[offer_hash]": [60],
		"/support-chatbot": [62],
		"/terminate": [63],
		"/tutor-offer": [64],
		"/universal/magic-link-redeem": [65],
		"/unsupported-browser": [66],
		"/upgrade": [67]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';